/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateUpdateExaminedDto } from './CreateUpdateExaminedDto';
import {
    CreateUpdateExaminedDtoFromJSON,
    CreateUpdateExaminedDtoFromJSONTyped,
    CreateUpdateExaminedDtoToJSON,
} from './CreateUpdateExaminedDto';
import type { CreateUpdateExamWithTestsDto } from './CreateUpdateExamWithTestsDto';
import {
    CreateUpdateExamWithTestsDtoFromJSON,
    CreateUpdateExamWithTestsDtoFromJSONTyped,
    CreateUpdateExamWithTestsDtoToJSON,
} from './CreateUpdateExamWithTestsDto';

/**
 * 
 * @export
 * @interface CreateUpdateExternalReferralDto
 */
export interface CreateUpdateExternalReferralDto {
    /**
     * 
     * @type {CreateUpdateExaminedDto}
     * @memberof CreateUpdateExternalReferralDto
     */
    examined?: CreateUpdateExaminedDto | null;
    /**
     * 
     * @type {CreateUpdateExamWithTestsDto}
     * @memberof CreateUpdateExternalReferralDto
     */
    examWithTests?: CreateUpdateExamWithTestsDto | null;
}

/**
 * Check if a given object implements the CreateUpdateExternalReferralDto interface.
 */
export function instanceOfCreateUpdateExternalReferralDto(value: object): value is CreateUpdateExternalReferralDto {
    return true;
}

export function CreateUpdateExternalReferralDtoFromJSON(json: any): CreateUpdateExternalReferralDto {
    return CreateUpdateExternalReferralDtoFromJSONTyped(json, false);
}

export function CreateUpdateExternalReferralDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateExternalReferralDto {
    if (json == null) {
        return json;
    }
    return {
        
        'examined': json['examined'] == null ? undefined : CreateUpdateExaminedDtoFromJSON(json['examined']),
        'examWithTests': json['examWithTests'] == null ? undefined : CreateUpdateExamWithTestsDtoFromJSON(json['examWithTests']),
    };
}

export function CreateUpdateExternalReferralDtoToJSON(value?: CreateUpdateExternalReferralDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'examined': CreateUpdateExaminedDtoToJSON(value['examined']),
        'examWithTests': CreateUpdateExamWithTestsDtoToJSON(value['examWithTests']),
    };
}

